export default function KofiButton() {
  return (
    <a
      href="https://ko-fi.com/cosminmp"
      target="_blank"
      rel="noopener noreferrer"
      className="button-link kofi"
    >
      ☕ Donate
    </a>
  )
}
